import ApplicationSerializer from 'eflex/serializers/application';

export default class OeeButtonSerializer extends ApplicationSerializer {
  attrs = {
    oeeStates: {
      deserialize: false,
      serialize: false,
    },
    triggers: {
      embedded: 'always',
    },
    triggerConfigs: {
      embedded: 'always',
    },
    oeeHardwareInput: {
      embedded: 'always',
    },
  };
}
